/* ABSCENTS — Mi perfumero en la ficha del perfume (fase 2).
   Arriba de las reseñas: quién lo tiene en su perfumero. En cada reseña de Judge.me:
   la tarjeta del perfumero de quien la escribió y las respuestas de otros clientes.
   Habla con la app por el proxy /apps/perfumero. */
(function () {
  'use strict';
  var raiz = document.getElementById('abx-pf-ficha');
  if (!raiz || !raiz.dataset.proxy) return;
  var PROXY = raiz.dataset.proxy.replace(/\/$/, '');
  var PRODUCTO = raiz.dataset.producto || '';
  var HANDLE = raiz.dataset.handle || '';
  var SESION = raiz.dataset.sesion === '1';
  var LOGIN = raiz.dataset.login || '/account/login';
  var PERFUMERO = raiz.dataset.perfumero || '/pages/perfumero';
  var NOMBRE = { n: raiz.dataset.n || '', a: raiz.dataset.a || '' };

  var S = { social: null, yo: null, autor: null, datos: {}, vistas: {}, cola: [], enCurso: false, primera: true, guardando: false, quienes: null };
  var porElemento = typeof WeakMap === 'function' ? new WeakMap() : null;

  /* ---------- utilidades ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function consulta(params) {
    var p = new URLSearchParams();
    Object.keys(params || {}).forEach(function (k) { if (params[k] != null && params[k] !== '') p.set(k, params[k]); });
    if (SESION && NOMBRE.n) { p.set('n', NOMBRE.n); if (NOMBRE.a) p.set('a', NOMBRE.a); }
    var t = p.toString();
    return t ? '?' + t : '';
  }
  function api(metodo, ruta, params, cuerpo) {
    return fetch(PROXY + ruta + consulta(params), {
      method: metodo,
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: cuerpo === undefined ? undefined : JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().catch(function () { return { ok: false, motivo: 'red' }; }).then(function (d) {
        if (!r.ok || !d || !d.ok) {
          var e = new Error((d && d.motivo) || 'http ' + r.status);
          e.motivo = (d && d.motivo) || 'red';
          throw e;
        }
        return d;
      });
    });
  }
  var MAYUS = /^(edp|edt|edc|ii|iii|iv|vi|xi|xii|xx|xxv|br540|ysl|dkny|bdk|mdci|cdg|ck|nyc|usa|uk)$/;
  var MENORES = ['de', 'du', 'des', 'la', 'le', 'les', 'el', 'los', 'las', 'et', 'of', 'the', 'y', 'and', 'di', 'da', 'del', 'pour', 'en', 'a', 'au', 'aux', 'by', 'in', 'on'];
  function bonito(t) {
    t = String(t || '').replace(/\s+\d{2,3}\s*ml\b.*$/i, '').trim();
    if (!t || t !== t.toUpperCase()) return t;
    return t.toLowerCase().split(/(\s+)/).map(function (w, i) {
      if (!w.trim()) return w;
      if (MAYUS.test(w)) return w.toUpperCase();
      if (i > 0 && MENORES.indexOf(w) >= 0) return w;
      w = w.charAt(0).toUpperCase() + w.slice(1);
      return w.replace(/^([^\s'’]{1,2}['’])(.)/, function (m, a, b) { return a + b.toUpperCase(); });
    }).join('');
  }
  function iniciales(nombre, alias) {
    var base = String(nombre || '').trim() || String(alias || '').replace(/[._]/g, ' ');
    var p = base.split(/\s+/).filter(Boolean);
    return ((p[0] || '?').charAt(0) + (p[1] ? p[1].charAt(0) : '')).toUpperCase();
  }
  function perfilUrl(alias) { return PERFUMERO + '?u=' + encodeURIComponent(alias); }
  function hace(ms) {
    var s = Math.max(0, (Date.now() - ms) / 1000);
    if (s < 60) return 'ahora';
    if (s < 3600) return 'hace ' + Math.floor(s / 60) + ' min';
    if (s < 86400) return 'hace ' + Math.floor(s / 3600) + ' h';
    if (s < 7 * 86400) { var d = Math.floor(s / 86400); return 'hace ' + d + (d === 1 ? ' día' : ' días'); }
    return new Date(ms).toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }
  function formatoTxt(este) {
    if (!este) return '';
    var f = este.tipo === 'frasco' ? 'en frasco' + (este.ml ? ' de ' + este.ml + ' ml' : '') : este.tipo ? 'en decant' + (este.ml ? ' de ' + este.ml + ' ml' : '') : '';
    if (este.estado === 'tengo') return 'Este lo tiene' + (f ? ' ' + f : '');
    if (este.estado === 'tuve') return 'Este lo tuvo' + (f ? ' ' + f : '');
    if (este.estado === 'quiero') return 'Este lo quiere probar';
    return '';
  }
  var toastT;
  function toast(txt) {
    var t = document.querySelector('.abx-rs-toast');
    if (!t) { t = document.createElement('div'); t.className = 'abx-rs-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = txt;
    clearTimeout(toastT);
    toastT = setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 2800);
  }
  function mensajeError(e) {
    var m = e && e.motivo;
    if (m === 'sin-sesion' || m === 'vencida') return 'Tu sesión expiró. Vuelve a iniciar sesión.';
    if (m === 'comprador') return 'Para responder necesitas al menos una compra en ABSCENTS.';
    if (m === 'limite-dia') return 'Llegaste al máximo de respuestas por hoy.';
    if (m === 'texto') return 'Escribe un poco más.';
    if (m === 'resena') return 'Esta reseña ya no está disponible.';
    if (m === 'capacidad') return 'Por ahora no pudimos guardarlo. Intenta de nuevo en unas horas.';
    return 'Algo falló. Intenta de nuevo en un momento.';
  }
  var FLECHA = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  var ABAJO = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var RESPONDER = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 8L5 12l5 4"/><path d="M5 12h9a5 5 0 0 1 5 5v1"/></svg>';
  var X = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  /* ---------- quién lo tiene ---------- */
  function pintarSocial() {
    var s = S.social;
    if (!s) { raiz.innerHTML = ''; raiz.hidden = true; return; }
    raiz.hidden = false;
    var h = '<section class="abx-rs-social" aria-label="En los perfumeros de ABSCENTS"><span class="abx-rs-kicker">En los perfumeros</span>';
    if (s.tienen || s.quieren) {
      var caras = (s.caras || []).slice(0, 4).map(function (c, i) {
        return '<a class="abx-rs-cara abx-rs-cara--' + (i % 3) + '" href="' + esc(perfilUrl(c.alias)) + '" title="' + esc(c.nombre || '@' + c.alias) + '" aria-label="Perfumero de ' + esc(c.nombre || c.alias) + '">' + esc(iniciales(c.nombre, c.alias)) + '</a>';
      });
      var resto = s.tienen - caras.length;
      var abierto = !!(S.quienes && S.quienes.abierto);
      if (resto > 0 && caras.length) caras.push('<button type="button" class="abx-rs-cara abx-rs-cara--mas" data-quienes="mas" aria-expanded="' + abierto + '" aria-controls="abx-rs-quienes" aria-label="Ver quiénes lo tienen">+' + resto + '</button>');
      var partes = [];
      if (s.tienen) partes.push('<b>' + s.tienen + '</b> lo ' + (s.tienen === 1 ? 'tiene' : 'tienen'));
      if (s.quieren) partes.push('<b>' + s.quieren + '</b> lo ' + (s.quieren === 1 ? 'quiere' : 'quieren'));
      h += '<div class="abx-rs-fila">' + (caras.length ? '<span class="abx-rs-caras">' + caras.join('') + '</span>' : '') +
        (s.tienen
          ? '<button type="button" class="abx-rs-cuenta abx-rs-cuenta--btn" data-quienes="cuenta" aria-expanded="' + abierto + '" aria-controls="abx-rs-quienes">' + partes.join(' · ') + '<span class="abx-rs-giro">' + ABAJO + '</span></button>'
          : '<span class="abx-rs-cuenta">' + partes.join(' · ') + '</span>') + '</div>';
      if (s.tienen) h += quienesHtml();
      if (s.insignias) h += '<span class="abx-rs-insignias"><span aria-hidden="true">◆</span>Es la insignia de ' + s.insignias + (s.insignias === 1 ? ' cliente' : ' clientes') + '</span>';
    } else {
      h += '<p class="abx-rs-vacio">Aún nadie lo tiene en su perfumero. Sé el primero.</p>';
    }
    var yo = S.yo && S.yo.estado;
    h += '<div class="abx-rs-botones">';
    if (!SESION) {
      h += '<a class="abx-rs-boton" href="' + esc(LOGIN) + '">Lo tengo</a><a class="abx-rs-boton" href="' + esc(LOGIN) + '">Lo quiero</a>';
    } else {
      h += yo === 'tengo'
        ? '<a class="abx-rs-boton abx-rs-boton--si" href="' + esc(PERFUMERO) + '">✓ En tu perfumero</a>'
        : '<button type="button" class="abx-rs-boton" data-poner="tengo">' + (yo === 'tuve' ? 'Lo tengo otra vez' : 'Lo tengo') + '</button>';
      h += yo === 'quiero'
        ? '<a class="abx-rs-boton abx-rs-boton--si" href="' + esc(PERFUMERO) + '">✓ En tu lista</a>'
        : yo === 'tengo' ? '' : '<button type="button" class="abx-rs-boton" data-poner="quiero">Lo quiero</button>';
    }
    h += '</div></section>';
    raiz.innerHTML = h;
  }
  /* ---------- la lista de quién lo tiene (se abre desde el +N o el conteo) ---------- */
  function formatoCorto(este) {
    if (!este || !este.tipo) return '';
    return (este.tipo === 'frasco' ? 'Frasco' : 'Decant') + (este.ml ? ' ' + este.ml + ' ml' : '');
  }
  function quienesHtml() {
    var Q = S.quienes;
    if (!Q || !Q.abierto) return '<div class="abx-rs-quienes" id="abx-rs-quienes" hidden></div>';
    var privados = Math.max(0, Q.total - Q.publicos);
    var h = '<div class="abx-rs-quienes" id="abx-rs-quienes"><div class="abx-rs-quienes__lista">';
    h += Q.personas.map(function (p) {
      var meta = [];
      if (p.insignia) meta.push('<span aria-hidden="true">◆</span> ' + esc(bonito(p.insignia)));
      var f = formatoCorto(p.este);
      if (f) meta.push(esc(f));
      meta.push(p.n + (p.n === 1 ? ' perfume' : ' perfumes'));
      return '<a class="abx-rs-q" href="' + esc(perfilUrl(p.alias)) + '">' +
        '<span class="abx-rs-ini' + (p.yo ? ' abx-rs-ini--yo' : '') + '" aria-hidden="true">' + esc(iniciales(p.nombre, p.alias)) + '</span>' +
        '<span class="abx-rs-q__txt"><span class="abx-rs-q__nombre">' + esc(p.yo ? 'Tú' : (p.nombre || '@' + p.alias)) + ' <small>@' + esc(p.alias) + '</small></span>' +
        '<span class="abx-rs-q__meta">' + meta.join(' · ') + '</span></span>' + FLECHA + '</a>';
    }).join('');
    h += '</div>';
    var nota = '';
    if (Q.cargando) nota = 'Cargando…';
    else if (Q.error) nota = 'No se pudo cargar la lista.';
    else if (!Q.personas.length) nota = privados === 1 ? 'Quien lo tiene mantiene su perfumero privado.' : 'Quienes lo tienen mantienen su perfumero privado.';
    else if (privados && !Q.mas) nota = privados === 1 ? 'Y 1 más con su perfumero privado.' : 'Y ' + privados + ' más con su perfumero privado.';
    var boton = Q.error ? 'Reintentar' : Q.mas && !Q.cargando ? 'Ver más' : '';
    if (nota || boton) h += '<div class="abx-rs-quienes__pie"><span>' + esc(nota) + '</span>' + (boton ? '<button type="button" data-quienes-mas>' + boton + '</button>' : '') + '</div>';
    return h + '</div>';
  }
  function cargarQuienes() {
    var Q = S.quienes;
    if (!Q || Q.cargando) return;
    Q.cargando = true;
    Q.error = false;
    pintarSocial();
    api('GET', '/ficha/quienes', { handle: HANDLE, pagina: String(Q.siguiente) }).then(function (d) {
      Q.cargando = false;
      Q.personas = Q.personas.concat(d.personas || []);
      Q.mas = !!d.mas;
      Q.total = d.total || 0;
      Q.publicos = d.publicos || 0;
      Q.siguiente = (d.pagina || 0) + 1;
      pintarSocial();
    }, function () {
      Q.cargando = false;
      Q.error = true;
      pintarSocial();
    });
  }
  function reiniciarQuienes() {
    if (!S.quienes) return;
    S.quienes.personas = [];
    S.quienes.siguiente = 0;
    S.quienes.mas = false;
    if (S.quienes.abierto) cargarQuienes();
  }

  raiz.addEventListener('click', function (e) {
    var t = e.target.closest('[data-quienes]');
    if (t) {
      var cual = t.getAttribute('data-quienes');
      if (!S.quienes) S.quienes = { abierto: false, personas: [], siguiente: 0, mas: false, total: 0, publicos: 0, cargando: false, error: false };
      S.quienes.abierto = !S.quienes.abierto;
      if (S.quienes.abierto && !S.quienes.personas.length) cargarQuienes();
      else pintarSocial();
      var otra = raiz.querySelector('[data-quienes="' + cual + '"]');
      if (otra) otra.focus({ preventScroll: true });
      return;
    }
    if (e.target.closest('[data-quienes-mas]')) { cargarQuienes(); return; }
    var b = e.target.closest('[data-poner]');
    if (!b || S.guardando) return;
    var estado = b.dataset.poner;
    S.guardando = true;
    b.disabled = true;
    api('POST', '/item', null, { handle: HANDLE, estado: estado }).then(function (d) {
      var antes = S.yo && S.yo.estado;
      S.yo = { id: d.item.id, estado: d.item.estado };
      if (S.social) {
        if (antes === 'tengo') S.social.tienen--;
        if (antes === 'quiero') S.social.quieren--;
        if (estado === 'tengo') S.social.tienen++;
        if (estado === 'quiero') S.social.quieren++;
      }
      S.guardando = false;
      pintarSocial();
      if (estado === 'tengo' || antes === 'tengo') reiniciarQuienes();
      toast(estado === 'tengo' ? 'Listo, ya está en tu perfumero' : 'Listo, está en tu lista de “Quiero”');
    }, function (err) {
      S.guardando = false;
      b.disabled = false;
      toast(mensajeError(err));
    });
  });

  /* ---------- reseñas de Judge.me ---------- */
  function claveDe(el) {
    var u = String(el.getAttribute('data-review-id') || '').toLowerCase();
    var ep = NaN;
    var t = el.querySelector('time[datetime]');
    if (t) ep = Math.floor(Date.parse(t.getAttribute('datetime')) / 1000);
    if (!isFinite(ep)) {
      // Judge.me: <span class="jdgm-rev__timestamp" data-content="2026-05-13 20:56:50 UTC">
      var s = el.querySelector('.jdgm-rev__timestamp[data-content]');
      var m = s && String(s.getAttribute('data-content')).match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.\d+)?\s*(?:UTC|Z|([+-])(\d{2}):?(\d{2}))?/i);
      if (m) {
        ep = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]) / 1000;
        if (m[7]) ep -= (m[7] === '-' ? -1 : 1) * (+m[8] * 3600 + +m[9] * 60);
      }
    }
    return { u: /^[a-f0-9-]{36}$/.test(u) ? u : '', t: isFinite(ep) ? ep : '', a: esAnonima(el) ? 1 : 0 };
  }
  // Judge.me la muestra como "Anónimo" o solo con iniciales: no se enlaza a su perfumero
  function esAnonima(el) {
    var a = el.querySelector('.jdgm-rev__author');
    var n = a ? a.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!n || /^(an[oó]nim[oa]s?|anonymous|anonyme|anonym)$/i.test(n)) return true;
    var partes = n.split(/[\s.]+/).filter(Boolean);
    return partes.every(function (p) { return p.length === 1; });
  }
  function textoClave(k) { return k.u + '~' + k.t + '~' + k.a; }
  function datoDe(k) { return (k.u && S.datos['u' + k.u]) || (k.t && S.datos['t' + k.t]) || null; }

  function buscarResenas() {
    var nuevas = [];
    document.querySelectorAll('.jdgm-rev').forEach(function (el) {
      if (el.closest('.jdgm-carousel, .jdgm-carousel-wrapper, .jdgm-all-reviews-page')) return;
      var k = claveDe(el);
      if (!k.u && !k.t) return;
      var tk = textoClave(k);
      el.setAttribute('data-abx-clave', tk);
      var d = datoDe(k);
      if (d) { if (!el.querySelector('.abx-rs')) decorar(el, d); return; }
      if (!S.vistas[tk]) { S.vistas[tk] = 1; nuevas.push(tk); }
    });
    if (nuevas.length) { S.cola = S.cola.concat(nuevas); pedir(); }
  }
  var temporizador;
  function pedir() {
    clearTimeout(temporizador);
    temporizador = setTimeout(function () {
      if (S.enCurso) return;
      var lote = S.cola.splice(0, 30);
      if (!lote.length && !S.primera) return;
      S.enCurso = true;
      var params = { producto: PRODUCTO, handle: HANDLE, k: lote.join(',') };
      if (S.primera) params.social = '1';
      api('GET', '/ficha', params).then(function (d) {
        if (S.primera) {
          S.primera = false;
          S.social = d.social;
          S.yo = d.yo;
          pintarSocial();
        }
        if (d.autor) S.autor = d.autor;
        (d.resenas || []).forEach(guardarDato);
        S.enCurso = false;
        buscarResenas();
        irAlHash();
        if (S.cola.length) pedir();
      }, function () {
        S.enCurso = false;
        if (S.primera) { S.primera = false; raiz.hidden = true; }
      });
    }, S.primera ? 0 : 180);
  }
  function guardarDato(r) {
    if (r.u) S.datos['u' + r.u] = r;
    if (r.t) S.datos['t' + r.t] = r;
  }

  function tarjetaHtml(t, nombreDom) {
    if (!t) return '';
    var meta = [t.n + (t.n === 1 ? ' perfume' : ' perfumes')];
    var este = formatoTxt(t.este);
    if (este) meta.push(este);
    return '<a class="abx-rs-tarjeta" href="' + esc(perfilUrl(t.alias)) + '" aria-label="Ver el perfumero de ' + esc(t.nombre || nombreDom || t.alias) + '">' +
      '<span class="abx-rs-rombo" aria-hidden="true">◆</span>' +
      '<span class="abx-rs-tarjeta__txt"><span class="abx-rs-mini">' + (t.insignia ? 'Su perfumero · insignia' : 'Su perfumero') + '</span>' +
      '<span class="abx-rs-tarjeta__nombre">' + esc(t.insignia ? bonito(t.insignia) : (t.nombre || '@' + t.alias)) + '</span>' +
      '<span class="abx-rs-tarjeta__meta">' + esc(meta.join(' · ')) + '</span></span>' + FLECHA + '</a>';
  }
  /* v112: el perfumero va integrado al ícono y al nombre que ya trae la reseña de Judge.me
     (antes era una tarjeta aparte que repetía el nombre). */
  function limpiarCabecera(el) {
    el.querySelectorAll('.abx-rs-pf, .abx-rs-ava').forEach(function (n) { n.parentNode.removeChild(n); });
    var a = el.querySelector('.jdgm-rev__author .abx-rs-autor');
    if (a) a.parentNode.replaceChild(document.createTextNode(a.textContent), a);
    el.classList.remove('abx-rs-con-pf');
  }
  function cabeceraPerfumero(el, t, nombreDom) {
    limpiarCabecera(el);
    if (!t) return;
    var url = perfilUrl(t.alias);
    var etiqueta = 'Ver el perfumero de ' + (t.nombre || nombreDom || t.alias);
    var autor = el.querySelector('.jdgm-rev__author');
    if (autor && !autor.querySelector('a')) {
      var a = document.createElement('a');
      a.className = 'abx-rs-autor';
      a.href = url;
      a.setAttribute('aria-label', etiqueta);
      a.textContent = autor.textContent.trim();
      autor.textContent = '';
      autor.appendChild(a);
    }
    var icono = el.querySelector('.jdgm-rev__icon');
    if (icono) {
      var av = document.createElement('a');
      av.className = 'abx-rs-ava';
      av.href = url;
      av.tabIndex = -1;
      av.setAttribute('aria-hidden', 'true');
      icono.appendChild(av);
    }
    var meta = [t.n + (t.n === 1 ? ' perfume' : ' perfumes')];
    var este = formatoTxt(t.este);
    if (este) meta.push(este);
    var linea = document.createElement('a');
    linea.className = 'abx-rs-pf';
    linea.href = url;
    linea.setAttribute('aria-label', etiqueta);
    linea.innerHTML = '<span class="abx-rs-rombo" aria-hidden="true">◆</span>' +
      '<span class="abx-rs-pf__tit">' + esc(t.insignia ? bonito(t.insignia) : 'Su perfumero') + '</span>' +
      '<span class="abx-rs-pf__meta">' + esc(meta.join(' · ')) + FLECHA + '</span>';
    var wrap = el.querySelector('.jdgm-rev__author-wrapper');
    var cab = el.querySelector('.jdgm-rev__header');
    if (wrap && wrap.parentNode) wrap.parentNode.insertBefore(linea, wrap.nextSibling);
    else if (cab) cab.appendChild(linea);
    else return;
    el.classList.add('abx-rs-con-pf');
  }
  function respuestaHtml(r) {
    return '<div class="abx-rs-resp" data-resp="' + esc(r.id) + '">' +
      '<div class="abx-rs-resp__cab"><span class="abx-rs-ini" aria-hidden="true">' + esc(iniciales(r.nombre, r.alias)) + '</span>' +
      (r.alias ? '<a class="abx-rs-resp__alias" href="' + esc(perfilUrl(r.alias)) + '">@' + esc(r.alias) + '</a>' : '<span class="abx-rs-resp__alias">' + esc(r.nombre || 'Cliente') + '</span>') +
      (r.insignia ? '<span class="abx-rs-resp__ins"><span aria-hidden="true">◆</span> ' + esc(bonito(r.insignia)) + '</span>' : '') + '</div>' +
      '<p class="abx-rs-resp__txt">' + esc(r.texto) + '</p>' +
      '<div class="abx-rs-resp__pie"><span>' + esc(hace(r.creado)) + '</span>' +
      (r.retenida ? '<span class="abx-rs-pendiente">En revisión: solo tú la ves</span>' : '') +
      (r.mio ? '<button type="button" class="abx-rs-mini-btn" data-borrar="' + esc(r.id) + '">Borrar</button>'
        : SESION ? '<button type="button" class="abx-rs-mini-btn" data-reportar="' + esc(r.id) + '">Reportar</button>' : '') +
      '</div></div>';
  }
  function decorar(el, d, abrir) {
    var viejo = el.querySelector('.abx-rs');
    var estabaAbierto = viejo && viejo.querySelector('.abx-rs-hilo') && !viejo.querySelector('.abx-rs-hilo').hidden;
    if (viejo) viejo.parentNode.removeChild(viejo);
    if (porElemento) porElemento.set(el, d);
    el.id = el.id || 'abx-resena-' + d.id;
    var autor = el.querySelector('.jdgm-rev__author');
    var nombreDom = autor ? autor.textContent.trim() : '';
    var n = (d.respuestas || []).length;
    var abierto = abrir || estabaAbierto || (n > 0 && n <= 2);
    var caja = document.createElement('div');
    caja.className = 'abx-rs';
    caja.setAttribute('data-resena', d.id);
    cabeceraPerfumero(el, esAnonima(el) ? null : d.tarjeta, nombreDom);
    caja.innerHTML =
      '<div class="abx-rs-barra">' +
      (n ? '<button type="button" class="abx-rs-ver" data-ver aria-expanded="' + abierto + '">' + (abierto ? 'Ocultar respuestas' : n + (n === 1 ? ' respuesta' : ' respuestas')) + '<span class="abx-rs-giro">' + ABAJO + '</span></button>' : '') +
      '<button type="button" class="abx-rs-responder" data-responder>' + RESPONDER + 'Responder</button></div>' +
      '<div class="abx-rs-hilo"' + (abierto && n ? '' : ' hidden') + '>' + (d.respuestas || []).map(respuestaHtml).join('') + '</div>';
    var destino = el.querySelector('.jdgm-rev__content') || el;
    destino.appendChild(caja);
  }
  function datoDeCaja(caja) {
    var el = caja.closest('.jdgm-rev');
    if (porElemento && el && porElemento.get(el)) return { el: el, d: porElemento.get(el) };
    var k = el ? el.getAttribute('data-abx-clave') : '';
    var p = String(k || '').split('~');
    var d = datoDe({ u: p[0], t: Number(p[1]) || '' });
    return { el: el, d: d };
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.abx-rs [data-ver], .abx-rs [data-responder], .abx-rs [data-reportar], .abx-rs [data-borrar]');
    if (!b) return;
    var caja = b.closest('.abx-rs');
    var x = datoDeCaja(caja);
    if (!x.d) return;
    if (b.hasAttribute('data-ver')) {
      var hilo = caja.querySelector('.abx-rs-hilo');
      var abrir = hilo.hidden;
      hilo.hidden = !abrir;
      b.setAttribute('aria-expanded', String(abrir));
      var n = x.d.respuestas.length;
      b.firstChild.nodeValue = abrir ? 'Ocultar respuestas' : n + (n === 1 ? ' respuesta' : ' respuestas');
      return;
    }
    if (b.hasAttribute('data-responder')) { hojaResponder(x.el, x.d); return; }
    if (b.hasAttribute('data-reportar')) {
      b.disabled = true;
      api('POST', '/respuestas/' + b.dataset.reportar + '/reportar').then(function () {
        b.textContent = 'Reportada';
        toast('Gracias. La revisamos.');
      }, function (err) { b.disabled = false; toast(mensajeError(err)); });
      return;
    }
    if (b.hasAttribute('data-borrar')) {
      if (b.dataset.seguro !== '1') { b.dataset.seguro = '1'; b.textContent = 'Toca otra vez para borrar'; return; }
      b.disabled = true;
      api('POST', '/respuestas/' + b.dataset.borrar + '/borrar').then(function () {
        x.d.respuestas = x.d.respuestas.filter(function (r) { return r.id !== b.dataset.borrar; });
        decorar(x.el, x.d, true);
        toast('Respuesta borrada');
      }, function (err) { b.disabled = false; toast(mensajeError(err)); });
    }
  });

  /* ---------- hoja para responder ---------- */
  var hoja = null;
  function cerrarHoja() {
    if (!hoja) return;
    var h = hoja;
    hoja = null;
    if (h.capa.parentNode) h.capa.parentNode.removeChild(h.capa);
    document.documentElement.classList.remove('abx-rs-modal');
    if (h.foco && h.foco.focus && document.contains(h.foco)) h.foco.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && hoja) cerrarHoja(); });
  function hojaResponder(el, d) {
    cerrarHoja();
    var autorEl = el.querySelector('.jdgm-rev__author');
    var autor = autorEl ? autorEl.textContent.trim() : 'esta reseña';
    var tituloEl = el.querySelector('.jdgm-rev__title');
    var cuerpoEl = el.querySelector('.jdgm-rev__body');
    var notaEl = el.querySelector('.jdgm-rev__rating');
    var nota = notaEl ? Number(notaEl.getAttribute('data-score')) || 0 : 0;
    var cuerpo = cuerpoEl ? cuerpoEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (cuerpo.length > 170) cuerpo = cuerpo.slice(0, 168).replace(/\s+\S*$/, '') + '…';
    var capa = document.createElement('div');
    capa.className = 'abx-rs-capa';
    var h = '<div class="abx-rs-capa__fondo" data-cerrar></div><section class="abx-rs-hoja" role="dialog" aria-modal="true" aria-label="Responder a ' + esc(autor) + '">' +
      '<div class="abx-rs-hoja__asa" aria-hidden="true"></div>' +
      '<div class="abx-rs-hoja__cab"><h2>Responder a ' + esc(autor) + '</h2><button type="button" class="abx-rs-cerrar" data-cerrar aria-label="Cerrar">' + X + '</button></div>' +
      '<div class="abx-rs-cita">' +
      (nota ? '<span class="abx-rs-estrellas" role="img" aria-label="' + nota + ' de 5 estrellas">' + '★★★★★'.slice(0, nota) + '☆☆☆☆☆'.slice(0, 5 - nota) + '</span>' : '') +
      (tituloEl && tituloEl.textContent.trim() ? '<b>' + esc(tituloEl.textContent.trim()) + '</b>' : '') +
      (cuerpo ? '<span>' + esc(cuerpo) + '</span>' : '') + '</div>';
    if (!SESION) {
      h += '<p class="abx-rs-hoja__txt">Para responder, inicia sesión con tu cuenta de ABSCENTS. Tu respuesta sale con tu alias y tu insignia.</p>' +
        '<a class="abx-rs-boton abx-rs-boton--negro" href="' + esc(LOGIN) + '">Iniciar sesión</a>';
    } else {
      var a = S.autor || {};
      h += '<div class="abx-rs-como"><span class="abx-rs-ini abx-rs-ini--grande" aria-hidden="true">' + esc(iniciales(a.nombre || NOMBRE.n, a.alias)) + '</span>' +
        '<span class="abx-rs-como__txt"><span class="abx-rs-mini">Respondes como</span>' +
        '<span class="abx-rs-como__alias">' + esc(a.alias ? '@' + a.alias : (a.nombre || NOMBRE.n || 'Tu cuenta')) +
        (a.insignia ? ' <small><span aria-hidden="true">◆</span> ' + esc(bonito(a.insignia)) + '</small>' : '') + '</span></span>' +
        '<a class="abx-rs-cambiar" href="' + esc(PERFUMERO) + '#privacidad">Cambiar</a></div>' +
        '<div class="abx-rs-campo"><label for="abx-rs-texto">Tu respuesta</label>' +
        '<textarea id="abx-rs-texto" maxlength="500" rows="4" placeholder="Escribe tu respuesta…"></textarea>' +
        '<div class="abx-rs-ayuda"><span>Se publica al instante con tu alias y tu insignia.</span><span data-contador>0 / 500</span></div></div>' +
        '<p class="abx-rs-regla">Sé amable. ABSCENTS oculta las respuestas ofensivas, con datos personales o con spam.</p>' +
        '<p class="abx-rs-error" data-error hidden></p>' +
        '<button type="button" class="abx-rs-boton abx-rs-boton--negro" data-publicar disabled>Publicar respuesta</button>';
    }
    h += '</section>';
    capa.innerHTML = h;
    document.body.appendChild(capa);
    document.documentElement.classList.add('abx-rs-modal');
    hoja = { capa: capa, foco: document.activeElement };
    var area = capa.querySelector('textarea');
    var btn = capa.querySelector('[data-publicar]');
    var cont = capa.querySelector('[data-contador]');
    var err = capa.querySelector('[data-error]');
    var seccion = capa.querySelector('.abx-rs-hoja');
    seccion.setAttribute('tabindex', '-1');
    if (area && window.matchMedia('(min-width: 769px)').matches) area.focus(); else seccion.focus({ preventScroll: true });
    if (area) area.addEventListener('input', function () {
      cont.textContent = area.value.length + ' / 500';
      btn.disabled = area.value.trim().length < 2;
    });
    capa.addEventListener('click', function (e) {
      if (e.target.closest('[data-cerrar]')) { cerrarHoja(); return; }
      if (!e.target.closest('[data-publicar]') || btn.disabled) return;
      btn.disabled = true;
      btn.textContent = 'Publicando…';
      err.hidden = true;
      api('POST', '/resenas/' + d.id + '/responder', null, { texto: area.value }).then(function (r) {
        d.respuestas = (d.respuestas || []).concat([r.respuesta]);
        if (r.respuesta.alias && S.autor) S.autor.alias = r.respuesta.alias;
        cerrarHoja();
        decorar(el, d, true);
        toast(r.respuesta.retenida ? 'Tu respuesta quedó en revisión' : 'Listo, ya se ve tu respuesta');
      }, function (e2) {
        btn.disabled = false;
        btn.textContent = 'Publicar respuesta';
        err.textContent = mensajeError(e2);
        err.hidden = false;
      });
    });
  }

  /* ---------- enlaces desde Mi perfumero ---------- */
  var hashHecho = false;
  function irAlHash() {
    if (hashHecho) return;
    var h = location.hash;
    if (h === '#abx-resenar') {
      var boton = document.querySelector('.jdgm-write-rev-link');
      if (!boton) return;
      hashHecho = true;
      var w = document.querySelector('.jdgm-widget, #judgeme_product_reviews') || boton;
      w.scrollIntoView({ block: 'start' });
      setTimeout(function () { boton.click(); }, 350);
      return;
    }
    var m = h.match(/^#abx-resena-(\d+)$/);
    if (!m) return;
    var caja = document.querySelector('.abx-rs[data-resena="' + m[1] + '"]');
    if (!caja) return;
    hashHecho = true;
    var x = datoDeCaja(caja);
    if (x.el && x.d) { decorar(x.el, x.d, true); x.el.scrollIntoView({ block: 'start' }); }
  }

  /* ---------- arranque ---------- */
  var obs = new MutationObserver(function () {
    clearTimeout(obs.t);
    obs.t = setTimeout(function () { buscarResenas(); irAlHash(); }, 120);
  });
  obs.observe(document.body, { childList: true, subtree: true });
  buscarResenas();
  if (S.primera && !S.enCurso) pedir();
})();
